import React from 'react';

import { reduxForm } from 'redux-form';

import { businessTypeFields } from './fields';

class BusinessType extends React.Component {
    render() {
        return <></>;
    }
}

// TODO: remove this component when removing redux forms
export default reduxForm(
    {
        form: 'sign_up',
        fields: businessTypeFields,
        destroyOnUnmount: false,
        getFormState: (state, reduxMountPoint) => state[reduxMountPoint]
    },
    ({ fetched }) => ({
        initialValues: fetched.application.payload
    })
)(BusinessType);
